// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d111ac03","697":"f9bad81e"}[chunkId] + ".chunk.js";
};